import React, { useEffect, useState } from "react";
import format_number from "../../Helpers/number_formatter";
import Grid from "../../Components/Grid";
import { Pagination } from "rsuite";
import { showFacture } from "../../Helpers/showFacture";
import { ERP_APi } from "../../Api";

const Billings = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [filterModel, setFilterModel] = useState({
    pageIndex: 1,
    pageSize: 20,
    sortDirection: "DESC",
    sortField: "created",
  });

  const fetch = () => {
    ERP_APi.createERPApiEndpoint(
      "wind-billing/" + ERP_APi.ENDPOINTS_ERP.invoice + "/perPage",
      filterModel
    )
      .customGet()
      .then((res) => {
        console.log(res.data.content);
        setData(res.data.content);
        setTotalCount(res.data.totalElements);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetch();
  }, [filterModel]);

  const handlePrint = (id) => {
    const dataToPrint = data.find((facture) => facture.id === id);
    showFacture(dataToPrint);
  };

  const columns = [
    {
      value: "invoiceNumber",
      name: "Réference",
      render: (v) => <a>{v || "-"}</a>,
    },
    {
      value: "deliveryDate",
      name: "Date",
      render: (v) => <a>{v || "-"}</a>,
    },
    {
      value: "invoicetype",
      name: "Type",
      render: (v) => <a> {v || "-"}</a>,
    },
    {
      value: "lineModels",
      name: "Service",
      render: (v) => <a>{"-"}</a>,
    },
    {
      value: "totalTtc",
      name: "Montant",
      render: (v) => <a>{v ? format_number(v) : "-"}</a>,
    },
    {
      value: "devise",
      name: "Devise",
      render: (v) => <a>{v || "-"}</a>,
    },
  ];

  return (
    <div>
      <Grid
        printAction={(id) => handlePrint(id)}
        actionKey="id"
        noAdvancedActions
        actions={[]}
        columns={columns}
        rows={data}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.pageSize}
          activePage={filterModel.pageIndex}
          onChangePage={(pageIndex) => {
            window.scrollTo(0, 0);
            setFilterModel((prev) => {
              return { ...prev, pageIndex };
            });
          }}
          onChangeLimit={(pageSize) => {
            setFilterModel((prev) => {
              return { ...prev, pageSize, page: 1 };
            });
          }}
        />
      </div>
    </div>
  );
};

export default Billings;
